import React from "react";
import "./WelcomePage.css";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import moonLogo from "../../images/logo.svg";
import usaid_ict_logo from "../../images/usaid_si_ict-hub_.png";
import logo_White from "../../images/logotip_white_srp.png";

export default function WelcomePage() {
  const navigate = useNavigate();

  const handleCreateProfileClick = () => {
    navigate("/register");
  };

  const handleLoginClick = () => {
    navigate("/login");
  };

  return (
    <div className="background">
      <div className="partners">
        <img src={usaid_ict_logo} alt="usaid_icthub" />
        <img src={logo_White} alt="odlican3" />
        <img src={moonLogo} alt="moonstruckLogo" />
      </div>
      <div className="welcome-wrapper">
        <div className="title-w">
          Welcome to the Web 2.5 <br /> Academy educational platform!
        </div>
        <p className="welcome-text">
          We are launching to the moon!
          <span className="border-line"></span>
        </p>

        <Button
          onClick={handleCreateProfileClick}
          className="welcome-btn"
          variant="contained"
          sx={{
            background: "#71E5EB",
            textTransform: "none",
            padding: "12px",
            fontWeight: "600",
            color: "#0B1125",
            width: "400px",
          }}
        >
          Create profile
        </Button>
        <Button
          onClick={handleLoginClick}
          className="welcome-btn"
          variant="outlined"
          sx={{
            fontWeight: "600",
            textTransform: "none",
            padding: "12px",
            color: "#fff",
            width: "400px",
            borderColor: "#71E5EB",
            whiteSpace: "nowrap",
          }}
        >
          Log in with existing account
        </Button>
      </div>
    </div>
  );
}
